export class Process{
  categorie: string;
  class: string;
  public constructor(title,status){
    this.categorie= title;
    this.class = status;
  }
}
